import React from "react"
import ReactDOM from "react-dom"
import { UserProfile } from "../../hooks/userProfile"
import { ItineraryComponent } from "./ItineraryComponent"

export const priceFormatter = (price, hideCurrency) =>
  `${new Intl.NumberFormat("da-DK", { style: "decimal", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(price)}${
    hideCurrency ? "" : " DKK"
  }`
export const hosts = document.body && document.body.dataset.hosts && JSON.parse(document.body.dataset.hosts)
export const emailValidatingRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const scrollWithOffset = (el) => {
  const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset
  const yOffset = -100
  window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" })
}

/* Dataset from the HTML element:
   data-flight-info="@Model.FlightInfo.ToJson(true)"
   data-time="@Model.CurrentPage.Time"
   data-terminal-label="@Model.CurrentPage.TerminalLabel"
   data-gate-label="@Model.CurrentPage.GateLabel"
   data-status-label="@Model.CurrentPage.StatusLabel"
   data-change-link-string="@Model.ChangeLinkString"
   data-flight-id-link="@Url.Content("~/")api/FlightRedirection/Flight/@Model.FlightInfo.FlightId"
   data-current-page="@Model.CurrentPageJson"
   data-finger="@Model.FingerJson"
   data-gate="@Model.GateJson"
   data-airlines-page="@Url.ContentUrl(Model.AirlinesPage)"
   data-gate-closes="@Model.GateCloses"
   data-check-in-opens="@Model.CheckInOpens"
   data-boarding-opens="@Model.BoardingOpens"
   data-travel-guide-link="@Model.TravelGuideLink.ToString()"
   data-travel-information-data="@Model.TravelInformation"
   data-airline-hero-image="@Model.AirlineHeroImage"
   data-show-flight-info-background-box="@Model.ShowFlightInfoBackgroundBox"
   data-updated-label="@Model.CurrentPage.UpdatedLabel"
   data-marketing-consent="@Model.MarketingConsentData.ToJson(true)">
*/

export default class Itinerary {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.state = {
      flightInfo: elem.dataset.flightInfo,
    }
    this.init()
  }

  init() {
    const {
      flightInfo: flightInfoJson,
      time,
      terminalLabel,
      gateLabel,
      statusLabel,
      changeLinkString,
      flightIdLink,
      currentPage: currentPageJson,
      finger: fingerJson,
      gate: gateJson,
      airlinesPage: airlinesPageLink,
      gateCloses,
      checkInOpens,
      boardingOpens,
      travelGuideLink,
      travelInformationData: travelInformationDataJson,
      airlineHeroImage,
      showFlightInfoBackgroundBox,
      updatedLabel,
      marketingConsent: marketingConsentJson,
    } = this.elem.dataset

    const argsForProps = {
      flightInfo: flightInfoJson && JSON.parse(flightInfoJson),
      time,
      terminalLabel,
      gateLabel,
      statusLabel,
      changeLinkString,
      flightIdLink,
      currentPage: currentPageJson && JSON.parse(currentPageJson),
      finger: fingerJson && JSON.parse(fingerJson),
      gate: gateJson && JSON.parse(gateJson),
      airlinesPageLink,
      gateCloses,
      checkInOpens,
      boardingOpens,
      travelGuideLink,
      travelInformation: (travelInformationDataJson && JSON.parse(travelInformationDataJson)) || {},
      airlineHeroImage,
      showFlightInfoBackgroundBox,
      updatedLabel,
      marketingConsent: marketingConsentJson && JSON.parse(marketingConsentJson),
    }

    ReactDOM.unmountComponentAtNode(this.elem)
    ReactDOM.render(
      <UserProfile>
        {(profile) => {
          if (profile) {
            return <ItineraryComponent {...argsForProps} profile={profile} />
          } else {
            return <ItineraryComponent {...argsForProps} profile={null} />
          }
        }}
      </UserProfile>,
      this.elem,
    )
  }
}
